module.exports = __webpack_public_path__ + "static/media/send_white copy.d0d9bee9.svg";